import publicationIds from '@/utils/functions/beehiiv/publications';
import { NewsletterSubscription } from '@/utils/functions/subscribe-to-newsletter';

export interface BeehiivPost {
    id?: string;
    subtitle?: string;
    title?: string;
    authors?: string[];
    created?: number;
    status?: string;
    publish_date?: number;
    displayed_date?: number;
    split_tested?: boolean;
    subject_line?: string;
    preview_text?: string;
    slug?: string;
    thumbnail_url?: string;
    web_url?: string;
    audience?: string;
    platform?: string;
    content_tags?: string[];
    content?: Content;
    stats?: Stats;
}
export interface BeehiivPosts {
    data?: BeehiivPost[];
    limit?: number;
    page?: number;
    total_results?: number;
    total_pages?: number;
}

export interface Content {
    free?: Free;
    premium?: Premium;
}

export interface Free {
    web?: string;
    email?: string;
    rss?: string;
}

export interface Premium {
    web?: string;
    email?: string;
}

export interface Stats {
    email?: StatsEmail;
    web?: Web;
    clicks?: Click[];
}

export interface Click {
    url?: string;
    email?: WebClass;
    web?: WebClass;
    total_clicks?: number;
    total_unique_clicks?: number;
    total_click_through_rate?: number;
}

export interface WebClass {
    clicks?: number;
    unique_clicks?: number;
    click_through_rate?: number;
}

export interface StatsEmail {
    recipients?: number;
    opens?: number;
    unique_opens?: number;
    open_rate?: number;
    clicks?: number;
    unique_clicks?: number;
    click_rate?: number;
    unsubscribes?: number;
    spam_reports?: number;
}

export interface Web {
    views?: number;
    clicks?: number;
}

const fetchBeehiivPosts = async (
    publication: NewsletterSubscription,
    limit: number = 24,
    page: number = 1,
): Promise<BeehiivPosts | null> => {
    const url = `https://api.beehiiv.com/v2/publications/${publicationIds[publication]}/posts?expand%5B%5D=free_email_content&audience=all&platform=all&status=confirmed&limit=${limit}&page=${page}order_by=publish_date&direction=desc`;
    const options = {
        method: 'GET',
        headers: { Accept: 'application/json', Authorization: `Bearer ${process.env.BEEHIIV_API_KEY}` },
    };

    try {
        const response = await fetch(url, options);
        return await response.json();
    } catch (error) {
        console.error(error);
    }

    return null;
};

export default fetchBeehiivPosts;
